import { CircularProgress, Typography } from "@mui/material";
import React, { useState } from "react";

export const MyForm = ({
  onSubmit,
  placeholder = "",
  buttonText = "Soumettre",
  loading,
}: {
  onSubmit: (name: string) => void;
  placeholder?: string;
  buttonText?: string;
  loading?: boolean;
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleSubmit = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    onSubmit(inputValue);
  };

  const handleChange = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setInputValue(event.target.value);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="gradient-input">
        <input
          placeholder={placeholder}
          type="text"
          value={inputValue}
          onChange={handleChange}
          required
        />
      </div>
      <button type="submit">
        {!loading && (
          <Typography className="gradiant-text">{buttonText}</Typography>
        )}

        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress sx={{ zoom: 0.7, color: "#04d361" }} />
          </div>
        )}
      </button>
    </form>
  );
};
